//// セット商品に関する処理を記述
// セット商品カート追加処理
const addButton = document.getElementById('setAddButton');
if(addButton) {
  addButton.addEventListener('click',() => {
    setProductsAddToCart();
  });

  async function setProductsAddToCart(){
    const firstVariantId = addButton.dataset.firstId;
    const secondVariantId = addButton.dataset.secondId;
    const firstVariantSku = addButton.dataset.firstSku;
    const secondVariantSku = addButton.dataset.secondSku;
    const now = new Date();
    const dateTimeStr = String(now.getFullYear()) + String(now.getMonth() + 1).padStart(2, '0') + String(now.getDate()).padStart(2, '0') + String(now.getHours()).padStart(2, '0') + String(now.getMinutes()).padStart(2, '0') + String(now.getSeconds()).padStart(2, '0');
    const propertyValue = `sku${firstVariantSku}_sku${secondVariantSku}_${dateTimeStr}`;
    
    addButton.classList.add('is-loading');
    let formData = {
    'items': [
        {
            'id': firstVariantId,
            'quantity': 1,
            'properties' : {
            'セット商品': propertyValue
            }
        },
        {
            'id': secondVariantId,
            'quantity': 1,
            'properties' : {
            'セット商品': propertyValue
            }
        },
    ]
    };
    console.log('formData',formData);
    const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
    })

    if(response.ok){
      window.location.href = `${Shopify.routes.root}cart`;
    }else {
      addButton.classList.remove('is-loading');
    }
  }
}

// セット商品カート削除処理（イベント委譲版）
document.addEventListener('DOMContentLoaded', () => {
  // cart-items や document に委譲
  document.addEventListener('click', async (event) => {
    const setProductRemoveButton = event.target.closest('.set-product-remove');
    if (!setProductRemoveButton) return;

    console.log('セット商品削除ボタンクリック');
    event.preventDefault();

    // 削除する商品のセット商品プロパティを取得
    const setProperty = setProductRemoveButton.dataset.setProductProperty;
    if (!setProperty) return;

    const matchedLineKeys = [];

    // カート内の削除ボタンを全て確認
    const cartProductRemoves = document.querySelectorAll('.set-product-remove');
    cartProductRemoves.forEach(removeBtn => {
      if (!removeBtn.dataset || !removeBtn.dataset.setProductProperty) return;

      if (removeBtn.dataset.setProductProperty === setProperty && removeBtn.dataset.lineKey) {
        // 一致した場合 lineKey を追加
        matchedLineKeys.push(removeBtn.dataset.lineKey);

        // ローディングアニメーション表示
        const loader = removeBtn.closest('.cart-item')?.querySelector('.cart-item__loader');
        if (loader) loader.style.setProperty('display', 'block', 'important');
        document.getElementById('cart-items').classList.add('pointer-events-none');
      }
    });

    if (matchedLineKeys.length === 0) return; // 一致なしなら処理終了

    // updates オブジェクトを作成（lineKeyを0にすると削除）
    const updates = {};
    matchedLineKeys.forEach(lineKey => updates[lineKey] = 0);

    const url = new URL('/cart/update.js', window.location.origin);

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      const data = await response.json();
      console.log('カート更新後のデータ:', data);

      window.location.reload(); // ページリロードで反映
    } catch (error) {
      console.error('カート更新エラー:', error);
    }
  });
});
